
import React, { useEffect, useState, useRef, useContext } from 'react'
import { Button, Col, Form, FormControl, InputGroup, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle, Row, Tab, Tabs } from 'react-bootstrap'
import Select from 'react-select';
import GlobalContext from '../GlobalContext';
import makeAnimated from 'react-select/animated';
import { useNavigate } from 'react-router-dom';
import { useImmer } from 'use-immer';
import "../css/sidebar.css"
import "../css/inputs.css"
import GoodCheck from '../components/GoodCheck';
import ServiceContext from '../ServiceContext';
import TextContext from '../TextContext';
import socketIO from "socket.io-client";
import GoodNumber from '../components/GoodNumber';


const GroupSettings = ({submit, deleteSubmit, addGroup, setAddGroup, groupOptions}) => {

    const globalContext=useContext(GlobalContext)
    const textContext=useContext(TextContext)
    const serviceContext=useContext(ServiceContext)
    const animatedComponents = makeAnimated();
    const [selectedGroup, setSelectedGroup] = useState({ label: undefined, value: undefined })
    const [groupValues, setGroupValues] = useImmer({
        ID: undefined,
        gro_name: '',
        gro_show_level: undefined,
        gro_priority: undefined,
        gro_is_admin: undefined,
        gro_view_shops: undefined,
        gro_aer_event: undefined,
        gro_aer_apt: undefined,
        gro_aer_category: undefined,
        gro_aer_customer: undefined,
        gro_aer_user: undefined,
        gro_aer_shop: undefined,
        gro_manage_groups: undefined,
        gro_edit_name: undefined,
        gro_edit_password: undefined,
        gro_edit_pic: undefined,
        gro_edit_hours: undefined,
        gro_change_hour_format: undefined,
        gro_change_theme: undefined,
        gro_add_theme: undefined,
    })
    const [groupCheks, setGroupCheks] = useImmer({
        touched: {
            gro_name: false,
        },
        good: {
            gro_name: false,
        },
        bad: {
            gro_name: false,
        },
        message: ''
    })

    const addEditGroup = async () => {
        checkGroupValues()
        if (groupCheks.bad.gro_name) {
            return
        }
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        if (addGroup) {
            const body = {
                gro_name: groupValues.gro_name,
                gro_show_level: groupValues.gro_show_level,
                gro_priority: groupValues.gro_priority,
                gro_is_admin: groupValues.gro_is_admin,
                gro_view_shops: groupValues.gro_view_shops,
                gro_aer_event: groupValues.gro_aer_event,
                gro_aer_apt: groupValues.gro_aer_apt,
                gro_aer_category: groupValues.gro_aer_category,
                gro_aer_customer: groupValues.gro_aer_customer,
                gro_aer_user: groupValues.gro_aer_user,
                gro_aer_shop: groupValues.gro_aer_shop,
                gro_manage_groups: groupValues.gro_manage_groups,
                gro_edit_name: groupValues.gro_edit_name,
                gro_edit_password: groupValues.gro_edit_password,
                gro_edit_pic: groupValues.gro_edit_pic,
                gro_edit_hours: groupValues.gro_edit_hours,
                gro_change_hour_format: groupValues.gro_change_hour_format,
                gro_change_theme: groupValues.gro_change_theme,
                gro_add_theme: groupValues.gro_add_theme,
            }

            const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/groups`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body)
            })
            if(resp.status==200){
                serviceContext.set(draft=>{draft.Alerts.push({
                    ID: Math.random(),
                   message: textContext.get(['calendar', 'notify'], ['add_group'], textContext.value),
                    ttl: 2000
                })})
            } else {
                serviceContext.set(draft=>{draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['error_group'], textContext.value),
                    ttl: 2000
                })})
            }

            globalContext.set(draft=>{draft.Reloads.user=true})
            showEditGroup()

        } else {
            const body = {
                ID: groupValues.ID,
                gro_name: groupValues.gro_name,
                gro_show_level: groupValues.gro_show_level,
                gro_priority: groupValues.gro_priority,
                gro_is_admin: groupValues.gro_is_admin,
                gro_view_shops: groupValues.gro_view_shops,
                gro_aer_event: groupValues.gro_aer_event,
                gro_aer_apt: groupValues.gro_aer_apt,
                gro_aer_category: groupValues.gro_aer_category,
                gro_aer_customer: groupValues.gro_aer_customer,
                gro_aer_user: groupValues.gro_aer_user,
                gro_aer_shop: groupValues.gro_aer_shop,
                gro_manage_groups: groupValues.gro_manage_groups,
                gro_edit_name: groupValues.gro_edit_name,
                gro_edit_password: groupValues.gro_edit_password,
                gro_edit_pic: groupValues.gro_edit_pic,
                gro_edit_hours: groupValues.gro_edit_hours,
                gro_change_hour_format: groupValues.gro_change_hour_format,
                gro_change_theme: groupValues.gro_change_theme,
                gro_add_theme: groupValues.gro_add_theme,
            }

            const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/groups`, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body)
            })
            if(resp.status==200){
                serviceContext.set(draft=>{draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['group_modify'], textContext.value),
                    ttl: 2000
                })})
            } else {
                serviceContext.set(draft=>{draft.Alerts.push({
                    ID: Math.random(),
                    message: textContext.get(['calendar', 'notify'], ['error_modify_group'], textContext.value),
                    ttl: 2000
                })})
            }

            globalContext.set(draft=>{draft.Reloads.user=true})
        }
    }
    const aerToBool = (property, position) => {
        if (property) {
            return property.charAt(position) == '1'
        } else {
            return false
        }
    }
    const changeSelectedGroup = (e) => {
        setSelectedGroup(e)
        if(e.value===undefined){
            setGroupValues({
                ID: undefined,
                gro_name: '',
                gro_show_level: undefined,
                gro_priority: undefined,
                gro_is_admin: undefined,
                gro_view_shops: undefined,
                gro_aer_event: undefined,
                gro_aer_apt: undefined,
                gro_aer_category: undefined,
                gro_aer_customer: undefined,
                gro_aer_user: undefined,
                gro_aer_shop: undefined,
                gro_manage_groups: undefined,
                gro_edit_name: undefined,
                gro_edit_password: undefined,
                gro_edit_pic: undefined,
                gro_edit_hours: undefined,
                gro_change_hour_format: undefined,
                gro_change_theme: undefined,
                gro_add_theme: undefined,
            })
        } else {
            setGroupValues(globalContext.get.Agency.Groups.filter(gro => gro.ID == e.value)[0])
        }
    }
    const getAer = (property, value, position) => {
        const replacement = value ? '1' : '0'
        const nuova = property.slice(0, position) + replacement + property.slice(position + replacement.length)
        //console.log(nuova)
        return nuova
    }
    const showAddGroup = () => {
        setAddGroup(true)
        setGroupValues(draft => { draft.gro_name = '' })
        setGroupCheks({
            touched: {
                gro_name: false,
            },
            good: {
                gro_name: false,
            },
            bad: {
                gro_name: false,
            },
            message: ''
        })
    }
    const showEditGroup = () => {
        setAddGroup(false)
        setGroupValues(globalContext.get.Agency.Groups.filter(gro => gro.ID == selectedGroup.value)[0])
        setGroupCheks({
            touched: {
                gro_name: false,
            },
            good: {
                gro_name: false,
            },
            bad: {
                gro_name: false,
            },
            message: ''
        })
    }
    const checkGroupValues = () => {
        const groups = JSON.parse(JSON.stringify(globalContext.get.Agency.Groups.filter(gro => gro.ID != groupValues.ID && gro.gro_name == groupValues.gro_name)))
        if (groups && groups.length > 0) {
            setGroupCheks({
                touched: {
                    gro_name: groupCheks.touched.gro_name,
                },
                good: {
                    gro_name: false,
                },
                bad: {
                    gro_name: true,
                },
                message: 'Nome già utilizzato'
            })
        } else if (groupValues.gro_name.length < 3) {
            setGroupCheks({
                touched: {
                    gro_name: groupCheks.touched.gro_name,
                },
                good: {
                    gro_name: false,
                },
                bad: {
                    gro_name: true,
                },
                message: textContext.get(['sidebar', 'settings', 'groups'], ['us_min'], textContext.value)
            })
        } else if (groupValues.gro_name.length > 11) {
            setGroupCheks({
                touched: {
                    gro_name: groupCheks.touched.gro_name,
                },
                good: {
                    gro_name: false,
                },
                bad: {
                    gro_name: true,
                },
                message: textContext.get(['sidebar', 'settings', 'groups'], ['us_max'], textContext.value)
            })
        } else {
            setGroupCheks({
                touched: {
                    gro_name: groupCheks.touched.gro_name,
                },
                good: {
                    gro_name: true,
                },
                bad: {
                    gro_name: false,
                },
                message: ''
            })
        }

    }
    const deleteGroup = async () => {
        serviceContext.set(draft => { draft.Load.isLoading = draft.Load.isLoading + 1 })
        const Body = {
            ID: groupValues.ID
        }

        const resp = await fetch(`${globalContext.get.backendUrl}/papiv1/groups`, {
            method: 'DELETE',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(Body)
        })

        if (resp.status == 200) {
            globalContext.set(draft=>{draft.Reloads.user=true})
            serviceContext.set(draft=>{draft.Alerts.push({
                ID: Math.random(),
                message: textContext.get(['calendar', 'notify'], ['delete_group'], textContext.value),
                ttl: 2000
            })})
        } else if (resp.status == 503) {
            serviceContext.set(draft=>{draft.Alerts.push({
                ID: Math.random(),
                message: textContext.get(['calendar', 'notify'], ['error_delete_group'], textContext.value),
                ttl: 2000
            })})
        }//TODO - controllare che fubnzioni
    }
    const getPermission = (permission, pos = -1) => {
        if (globalContext.get) {
            if (globalContext.get.User) {
                if (globalContext.get.User.Groups) {
                    if (globalContext.get.User.Groups.length > 0) {
                        if (globalContext.get.User.Groups[0].gro_is_admin) {
                            return true
                        } else {
                            if (pos >= 0) {
                                return parseInt(globalContext.get.User.Groups[0][permission].charAt(pos))
                            } else {
                                return globalContext.get.User.Groups[0][permission]
                            }
                        }
                    }
                }
            }
        }
        return false
    }

    useEffect(() => {
        if(submit.get){
            addEditGroup()
            submit.set(false)
        }
        //console.log(window.location.pathname.split("/").pop() == 'calendar')
    }, [submit.get])
    useEffect(() => {
        if(deleteSubmit.get){
            deleteGroup()
            deleteSubmit.set(false)
        }
        //console.log(window.location.pathname.split("/").pop() == 'calendar')
    }, [deleteSubmit.get])
    useEffect(() => {

        if (globalContext.get) {
            if (globalContext.get.User.ID && globalContext.get.Shop.ID && globalContext.get.Agency.ID) {
                let l_groups = []
                const userGroup = globalContext.get.User.Groups[0]
                globalContext.get.Agency.Groups.forEach(gro => {
                    if (userGroup.gro_is_admin) {
                        if (!(gro.gro_is_admin && gro.gro_priority > userGroup.gro_priority)) {
                            l_groups.push({ label: gro.gro_name, value: gro.ID })
                        }
                    } else if (userGroup.gro_manage_groups) {
                        if (!(gro.gro_is_admin || gro.gro_priority > userGroup.gro_priority || gro.ID == userGroup.ID)) {
                            l_groups.push({ label: gro.gro_name, value: gro.ID })
                        }
                    }
                })
                
                if (globalContext.get.User.Groups[0].gro_is_admin) {
                    changeSelectedGroup(globalContext.get.User.Groups.length > 0 ? l_groups.filter(gr => gr.value == globalContext.get.User.Groups[0].ID)[0] : { label: undefined, value: undefined })
                } else {
                    changeSelectedGroup(l_groups.length > 0 ? l_groups[0] : { label: undefined, value: undefined })
                }
            }
        }
    }, [globalContext.get])
    useEffect(() => {
        checkGroupValues()
    }, [groupValues])


    return (
        <>
            {addGroup ? (
                <Row className='mt-4 mx-4'>
                    <button type='button' className='nac-button' onClick={showEditGroup}>{textContext.get(['sidebar', 'settings', 'groups'], ['edit_button'], textContext.value)}</button>
                </Row>
            ) : (
                <Row className='mt-4 mx-4'>
                    <button type='button' className='nac-button' onClick={showAddGroup}>{textContext.get(['sidebar', 'settings', 'groups'], ['add_button'], textContext.value)}</button>
                </Row>
            )}
            {!addGroup && (
                <Row className='mt-4'>
                    <Form.Label><p>{textContext.get(['sidebar', 'settings', 'groups'], ['group_select'], textContext.value)}</p></Form.Label>
                    <Select
                        id='select-pttp'
                        components={animatedComponents}
                        options={groupOptions}
                        value={selectedGroup}
                        onChange={(e) => changeSelectedGroup(e)}
                    />
                </Row>
            )}
            <Row className='mt-4'>
                <InputGroup hasValidation>
                    <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'groups'], ['group_name'], textContext.value)}</InputGroup.Text>
                    <FormControl
                        type='text'
                        placeholder='Default'
                        value={groupValues.gro_name}
                        onChange={(e) => setGroupValues(draft => { draft.gro_name = e.target.value })}
                        onFocus={(e) => setGroupCheks(draft => { draft.touched.gro_name = true })}
                        isValid={groupCheks.good.gro_name}
                        isInvalid={groupCheks.bad.gro_name}
                    />
                </InputGroup>
                <p className='nac-text' style={{ color: 'var(--accent-text-color)' }} >{groupCheks.message}</p>
            </Row>
            <Row className='mt-4'>
                <InputGroup hasValidation>
                    <InputGroup.Text>{textContext.get(['sidebar', 'settings', 'groups'], ['group_priority'], textContext.value)}</InputGroup.Text>
                    <GoodNumber
                        min={0}
                        max={globalContext.get.User.Groups[0].gro_priority}
                        value={groupValues.gro_priority}
                        classes='form-control'
                        onChange={(e) => setGroupValues(draft => { draft.gro_priority = e })}
                    // onFocus={(e) => setGroupCheks(draft => { draft.touched.gro_name = true })}
                    // isValid={groupCheks.good.gro_name}
                    // isInvalid={groupCheks.bad.gro_name}

                    />
                </InputGroup>
            </Row>
            {getPermission('gro_is_admin') &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['is_admin'], textContext.value)}
                        helpTitle={textContext.get(['sidebar', 'settings', 'groups'], ['admin_help'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={groupValues.gro_is_admin}
                        onChange={(e) => setGroupValues(draft => { draft.gro_is_admin = e.target.value })}
                    />
                </Row>
            }
            {getPermission('gro_view_shops') &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['view_shops'], textContext.value)}
                        helpTitle={textContext.get(['sidebar', 'settings', 'groups'], ['show_shops_help'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={groupValues.gro_view_shops}
                        onChange={(e) => setGroupValues(draft => { draft.gro_view_shops = e.target.value })}
                    />
                </Row>
            }
            {getPermission('gro_edit_name') &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['change_username'], textContext.value)}
                        helpTitle={textContext.get(['sidebar', 'settings', 'groups'], ['change_username_help'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={groupValues.gro_edit_name}
                        onChange={(e) => setGroupValues(draft => { draft.gro_edit_name = e.target.value })}
                    />
                </Row>
            }
            {getPermission('gro_edit_password') &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['change_password'], textContext.value)}
                        helpTitle={textContext.get(['sidebar', 'settings', 'groups'], ['change_password_help'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={groupValues.gro_edit_password}
                        onChange={(e) => setGroupValues(draft => { draft.gro_edit_password = e.target.value })}
                    />
                </Row>
            }
            {getPermission('gro_edit_pic') &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['change_pic'], textContext.value)}
                        helpTitle={textContext.get(['sidebar', 'settings', 'groups'], ['change_pic_help'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={groupValues.gro_edit_pic}
                        onChange={(e) => setGroupValues(draft => { draft.gro_edit_pic = e.target.value })}
                    />
                </Row>
            }
            {getPermission('gro_edit_hours') &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['change_hours'], textContext.value)}
                        helpTitle={textContext.get(['sidebar', 'settings', 'groups'], ['change_hours_help'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={groupValues.gro_edit_hours}
                        onChange={(e) => setGroupValues(draft => { draft.gro_edit_hours = e.target.value })}
                    />
                </Row>
            }
            {getPermission('gro_change_theme') &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['change_theme'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={groupValues.gro_change_theme}
                        onChange={(e) => setGroupValues(draft => { draft.gro_change_theme = e.target.value })}
                    />
                </Row>
            }
            {getPermission('gro_add_theme') &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['add_theme'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={groupValues.gro_add_theme}
                        onChange={(e) => setGroupValues(draft => { draft.gro_add_theme = e.target.value })}
                    />
                </Row>
            }
            <hr />
            {getPermission('gro_aer_event', 0) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['add', 'event'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_event, 0)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_event = getAer(draft.gro_aer_event, e.target.value, 0) })}
                    />
                </Row>
            }
            {getPermission('gro_aer_event', 1) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['edit', 'event'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_event, 1)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_event = getAer(draft.gro_aer_event, e.target.value, 1) })}
                    />
                </Row>
            }
            {getPermission('gro_aer_event', 2) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['delete', 'event'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_event, 2)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_event = getAer(draft.gro_aer_event, e.target.value, 2) })}
                    />
                </Row>
            }
            <hr />
            {getPermission('gro_aer_apt', 0) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['add', 'apt'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_apt, 0)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_apt = getAer(draft.gro_aer_apt, e.target.value, 0) })}
                    />
                </Row>
            }
            {getPermission('gro_aer_apt', 1) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['edit', 'apt'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_apt, 1)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_apt = getAer(draft.gro_aer_apt, e.target.value, 1) })}
                    />
                </Row>
            }
            {getPermission('gro_aer_apt', 2) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['delete', 'apt'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_apt, 2)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_apt = getAer(draft.gro_aer_apt, e.target.value, 2) })}
                    />
                </Row>
            }
            <hr />
            {getPermission('gro_aer_category', 0) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['add', 'category'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_category, 0)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_category = getAer(draft.gro_aer_category, e.target.value, 0) })}
                    />
                </Row>
            }
            {getPermission('gro_aer_category', 1) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['edit', 'category'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_category, 1)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_category = getAer(draft.gro_aer_category, e.target.value, 1) })}
                    />
                </Row>
            }
            {getPermission('gro_aer_category', 2) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['delete', 'category'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_category, 2)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_category = getAer(draft.gro_aer_category, e.target.value, 2) })}
                    />
                </Row>
            }
            <hr />
            {getPermission('gro_aer_customer', 0) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['add', 'customer'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_customer, 0)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_customer = getAer(draft.gro_aer_customer, e.target.value, 0) })}
                    />
                </Row>
            }
            {getPermission('gro_aer_customer', 1) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['edit', 'customer'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_customer, 1)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_customer = getAer(draft.gro_aer_customer, e.target.value, 1) })}
                    />
                </Row>
            }
            {getPermission('gro_aer_customer', 2) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['delete', 'customer'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_customer, 2)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_customer = getAer(draft.gro_aer_customer, e.target.value, 2) })}
                    />
                </Row>
            }
            <hr />
            {getPermission('gro_aer_user', 0) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['add', 'user'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_user, 0)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_user = getAer(draft.gro_aer_user, e.target.value, 0) })}
                    />
                </Row>
            }
            {getPermission('gro_aer_user', 1) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['edit', 'user'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_user, 1)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_user = getAer(draft.gro_aer_user, e.target.value, 1) })}
                    />
                </Row>
            }
            {getPermission('gro_aer_user', 2) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['delete', 'user'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_user, 2)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_user = getAer(draft.gro_aer_user, e.target.value, 2) })}
                    />
                </Row>
            }
            <hr />
            {getPermission('gro_aer_shop', 0) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['add', 'shop'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_shop, 0)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_shop = getAer(draft.gro_aer_shop, e.target.value, 0) })}
                    />
                </Row>
            }
            {getPermission('gro_aer_shop', 1) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['edit', 'shop'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_shop, 1)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_shop = getAer(draft.gro_aer_shop, e.target.value, 1) })}
                    />
                </Row>
            }
            {getPermission('gro_aer_shop', 2) &&
                <Row className='mt-4 mx-1'>
                    <GoodCheck
                        label={textContext.get(['sidebar', 'settings', 'groups'], ['delete', 'shop'], textContext.value)}
                        checkColor={globalContext.get.Theme.palette[3]}
                        defaultChecked={aerToBool(groupValues.gro_aer_event, 2)}
                        onChange={(e) => setGroupValues(draft => { draft.gro_aer_shop = getAer(draft.gro_aer_shop, e.target.value, 2) })}
                    />
                </Row>
            }
        </>
    )
}

export default GroupSettings